import api from '../../helpers/axios'

export const state = {
    smsTemplate: null,
    smsTemplates: []
};

export const getters = {
    smsTemplate: (state) => state.smsTemplate,
    smsTemplates: (state) => state.smsTemplates
};

export const mutations = {
    setSmsTemplate(state, newValue) {
        state.smsTemplate = newValue;
    },
    setSmsTemplates(state, newValue) {
        state.smsTemplates = newValue;
    },
};

export const actions = {
    createSmsTemplate(_,  data) {
        return new Promise((resolve) => {
            api.post("/sms-templates", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updateSmsTemplate(_, {id,data}) {
        return new Promise((resolve) => {
            api.put("/sms-templates/"+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deleteSmsTemplate(_, id) {
        return new Promise((resolve) => {
            api.delete("/sms-templates/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchSmsTemplate({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/sms-templates/"+id).then((res) => {
                commit("setSmsTemplate", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchSmsTemplates({ commit }, params) {
        return new Promise((resolve) => {
            api.get("/sms-templates", {params: {...params}}).then((res) => {
                commit("setSmsTemplates", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
